import { formatPrice } from 'utils';
import { logo_with_name } from 'utils/importFile';

interface SimpleProductItemProps {
  name: string;
  difference?: number;
  price?: number;
  imageUrl?: string;
  showInventoryQuantities?: boolean;
  expectedQuantity?: number;
  actualQuantity?: number | null;
}

const SimpleProductItem = ({
  name,
  difference,
  price,
  imageUrl,
  showInventoryQuantities = false,
  expectedQuantity = 0,
  actualQuantity,
}: SimpleProductItemProps) => {
  const hasActualQuantity = actualQuantity !== null && actualQuantity !== undefined;
  const inventoryDifference = hasActualQuantity ? (actualQuantity as number) - expectedQuantity : null;

  const inventoryDifferenceLabel =
    inventoryDifference === null
      ? 'Chưa kiểm'
      : inventoryDifference > 0
        ? `+${formatPrice(inventoryDifference)}`
        : formatPrice(inventoryDifference);

  return (
    <div className='w-full min-w-96 p-3 bg-black/5 rounded-2xl flex flex-col gap-2.5'>
      <div className='flex gap-3'>
        <div className='w-11 h-12 bg-black/10 rounded-lg overflow-hidden'>
          {imageUrl ? (
            <img
              src={imageUrl}
              alt={name}
              className='w-full h-full object-cover'
              onError={(e) => {
                (e.target as HTMLImageElement).src = logo_with_name;
              }}
            />
          ) : (
            <div className='w-full h-full bg-black/10'></div>
          )}
        </div>

        <div className='flex-1 flex flex-col gap-2.5'>
          <div className='text-black text-sm font-bold leading-tight'>{name}</div>

          {showInventoryQuantities && (
            <div className='grid grid-cols-3 gap-2.5'>
              <div className='flex flex-col gap-1'>
                <span className='text-black/60 text-xs font-medium leading-tight'>Tồn sổ</span>
                <span className='text-sm font-semibold leading-tight text-black'>{formatPrice(expectedQuantity)}</span>
              </div>
              <div className='flex flex-col gap-1'>
                <span className='text-black/60 text-xs font-medium leading-tight'>Thực tế</span>
                <span className='text-sm font-semibold leading-tight text-black'>
                  {hasActualQuantity ? formatPrice(actualQuantity as number) : '-'}
                </span>
              </div>
              <div className='flex flex-col gap-1'>
                <span className='text-black/60 text-xs font-medium leading-tight'>Chênh lệch</span>
                <span
                  className={`text-sm font-semibold leading-tight ${
                    inventoryDifference === null
                      ? 'text-black/60'
                      : inventoryDifference > 0
                        ? 'text-green-500'
                        : inventoryDifference < 0
                          ? 'text-red-500'
                          : 'text-black/60'
                  }`}
                >
                  {inventoryDifferenceLabel}
                </span>
              </div>
            </div>
          )}

          {difference !== undefined && !price && (
            <div className='flex gap-2.5'>
              <span className='text-black/60 text-sm font-medium leading-tight'>Chênh lệch:</span>
              <span
                className={`text-sm font-medium leading-tight ${difference > 0 ? 'text-green-500' : difference < 0 ? 'text-red-500' : 'text-black/60'}`}
              >
                {difference > 0 ? `+${difference}` : difference < 0 ? `${difference}` : '0'}
              </span>
            </div>
          )}
          {price !== undefined && (
            <div className='flex gap-2.5'>
              <span className='text-black/60 text-sm font-medium leading-tight'>Đơn giá:</span>
              <span className='text-sm text-[var(--primaryColor500)] font-medium leading-tight'>
                {formatPrice(price || 0)}
                <span className='ml-1'>VNĐ</span>
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SimpleProductItem;
